import { Button } from "@/components/ui/button";
import { ArrowRight, Building2 } from "lucide-react";
import { Link } from "react-router-dom";

const B2BCTA = () => {
  return (
    <section className="py-16 md:py-24 bg-gradient-to-br from-primary via-primary to-secondary/80">
      <div className="container mx-auto px-4 md:px-6">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 bg-white/10 px-4 py-2 rounded-full mb-6 border border-white/20">
            <Building2 className="w-4 h-4 text-secondary" />
            <span className="text-white/90 text-sm font-medium">For B2B Growth Leaders</span>
          </div>
          
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6">
            Ready to Build Your <span className="text-secondary">Growth Engine?</span>
          </h2>
          
          <p className="text-lg md:text-xl text-white/80 max-w-2xl mx-auto mb-8 leading-relaxed">
            Schedule a strategic review with our team. We will analyze your current position, 
            identify opportunities, and outline a roadmap to predictable pipeline growth.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-8">
            <Button 
              size="xl" 
              className="bg-secondary hover:bg-secondary/90 text-primary font-bold group"
              asChild
            >
              <Link to="/do-you-qualify">
                Schedule Strategic Review
                <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
              </Link>
            </Button>
            <Button 
              variant="outline" 
              size="xl" 
              className="bg-white/10 border-white/30 text-white hover:bg-white/20"
              asChild
            >
              <Link to="/enterprise">
                Explore Enterprise Solutions
              </Link>
            </Button>
          </div>

          <p className="text-white/60 text-sm">
            No commitment required • Confidential discussion • Typically responds within 24 hours
          </p>
        </div>
      </div>
    </section>
  );
};

export default B2BCTA;
